<template>
  <div>
    <!-- More info for Deadline and Region -->
    <more-info
      ref="more-info-modal"
      :title="$wording.submission_details.more_info_title"
    >
      <p v-text="$wording.submission_details.more_info1" />
      <p v-text="$sprintf($wording.submission_details.more_info_1_1, getRegion.name, $dayjs(getRegion.startDate, 'MM-DD-YYYY').format('MMM DD, YYYY'))" />
      <p v-html="$wording.submission_details.resource_for_landlords" />
    </more-info>

    <div class="border-bottom m-b-lg">
      <div class="container">
        <div class="columns m-t-none m-b-none">
          <div class="column">
            <div class="level mobile-multiline">
              <div class="level-item">
                <div>
                  <p class="heading">
                    Phase-in date
                    <a
                      alt="More Info"
                      title="More Info"
                      @click.prevent="showMoreInfo"
                    >
                      <i
                        class="fas fa-info-circle"
                        aria-hidden="true"
                      />
                    </a>
                  </p>
                  <p class="title">
                    <i
                      class="fad fa-calendar"
                      aria-hidden="true"
                    />
                    {{ $dayjs(getRegion.startDate, 'MM-DD-YYYY').format('MMM DD, YYYY') }}
                  </p>
                </div>
              </div>
              <div class="level-item">
                <div>
                  <p class="heading">
                    # Units
                  </p>
                  <p class="title has-text-centered">
                    {{ eligibilityCheck.numberOfUnits }}
                  </p>
                </div>
              </div>
              <div class="level-item">
                <div>
                  <p class="heading">
                    LHHP region
                    <a
                      alt="More Info"
                      title="More Info"
                      @click.prevent="showMoreInfo"
                    >
                      <i
                        class="fas fa-info-circle"
                        aria-hidden="true"
                      />
                    </a>
                  </p>
                  <p class="title">
                    {{ getRegion.name }}
                  </p>
                </div>
              </div>
              <div class="level-item">
                <div>
                  <p class="heading">
                    Build before 1978?
                  </p>
                  <p class="title">
                    <span v-show="eligibilityCheck.prior1978 === true">YES</span>
                    <span v-show="eligibilityCheck.prior1978 === false"> NO</span>
                  </p>
                </div>
              </div>
              <div
                v-if="eligibilityCheck.childUnderSix"
                class="level-item"
              >
                <div>
                  <p class="heading">
                    Child 6 years<br>old or younger
                  </p>
                  <p
                    class="title"
                    data-hj-suppress
                  >
                    <span v-show="eligibilityCheck.childUnderSix === true">YES</span>
                    <span v-show="eligibilityCheck.childUnderSix === false">NO</span>
                  </p>
                </div>
              </div>
              <div
                v-if="eligibilityCheck.licenseNumber"
                class="level-item"
              >
                <div>
                  <p class="heading">
                    License #
                  </p>
                  <p
                    ref="license-tooltip"
                    :data-tippy-content="$wording.ec.license_not_found"
                    class="title"
                    :class="{ 'has-text-danger': foundLicenseData === false }"
                  >
                    {{ eligibilityCheck.licenseNumber }}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="container">
      <div
        v-if="!loading"
        class="columns m-t-none"
      >
        <div class="column">
          <div class="columns is-vcentered m-b-none">
            <div class="column">
              <div class="content">
                <h3 class="m-b-none">
                  {{ $wording.submission_details.title_9 }}
                </h3>
                <p>
                  <strong>{{ numberOfUnitsSubmitted }}</strong> out of <strong>{{ eligibilityCheck.numberOfUnits }}</strong> required certifications submitted
                  <span v-if="eligibilityCheck.numberOfUnits < 50">
                    |
                    <router-link :to="{ name: 'details-inspections', params: $route.params }">
                      View all
                    </router-link>
                  </span>
                </p>
              </div>
            </div>
            <div
              v-if="!inspections.length"
              class="column is-narrow has-text-right"
            >
              <button
                class="button is-primary submitcertificate-button add-certification"
                @click="gotoSubmitInspections"
              >
                <span>ADD CERTIFICATION</span>
                <span class="icon">
                  <i
                    class="fas fa-plus-square"
                    aria-hidden="true"
                  />
                </span>
              </button>
              <!-- <small>
                <a
                  class="m-t-sm is-block has-text-centered"
                  @click="withdrawCertification"
                >
                  Withdraw certification
                </a>
              </small> -->
            </div>
          </div>
        </div>
      </div>
      <div class="container">
        <div class="columns">
          <div class="column">
            <p v-if="loading">
              Loading information, please wait...
            </p>
            <div class="container">
              <v-client-table
                v-if="inspections.length > 0 && !loading"
                class="custom-table-with-right-button-and-not-limit"
                :data="inspections"
                :columns="tableColumns"
                :options="tableOptions"
              >
                <template
                  v-if="submitCertification"
                  slot="afterFilterWrapper"
                >
                  <div class="is-flex-desktop custom-button-flex is-block-mobile">
                    <button
                      class="button is-primary addCertifcationButton add-certification"
                      @click="gotoSubmitInspections"
                    >
                      <span>ADD CERTIFICATION</span>
                      <span class="icon">
                        <i
                          class="fas fa-plus-square"
                          aria-hidden="true"
                        />
                      </span>
                    </button>
                    <!-- <small>
                      <a
                        class="m-t-sm is-block has-text-centered"
                        @click="withdrawCertification"
                      >
                        Withdraw certification
                      </a>
                    </small> -->
                  </div>
                </template>
                <!-- Name -->
                <template
                  slot="name"
                  slot-scope="props"
                >
                  {{ props.row.name }}
                </template>

                <!-- Inspection date -->
                <template
                  slot="inspectionDate"
                  slot-scope="props"
                >
                  <span v-text="$dayjs(props.row.inspectionDate).format('MM/DD/YYYY')" />
                </template>

                <!-- Inspection date -->
                <template
                  slot="expirationDate"
                  slot-scope="props"
                >
                  <span
                    v-if="props.row.inspectionType === 'LeadSafe'"
                    v-text="getExpirationDate(props.row.inspectionDate)"
                  />
                  <span
                    v-else
                    v-text="`N/A`"
                  />
                </template>

                <!-- Report Path -->
                <template
                  slot="report"
                  slot-scope="props"
                >
                  <a
                    class="link"
                    :href="props.row.reportDownloadUrl"
                    target="_blank"
                    download
                  >
                    <i
                      class="fas fa-download"
                      aria-hidden="true"
                    /> Report
                  </a>
                </template>
                <!-- Status -->
                <template
                  slot="status"
                  slot-scope="props"
                >
                  <!-- TODO: program tag style color -->
                  <status-tag :status="props.row.status" />
                </template>

                <!-- Inspection Type -->
                <template
                  slot="inspectionType"
                  slot-scope="props"
                >
                  <inspection-type
                    class="has-text-weight-semibold"
                    :type="props.row.inspectionType"
                  />
                </template>

                <template
                  slot="actions"
                  slot-scope="props"
                >
                  <router-link
                    v-if="!/Passed|Pending/gi.test(props.row.status) || isAdmin"
                    class="button is-small is-secondary edit-inspection"
                    tag="button"
                    :label="`Update ${props.row.name}`"
                    :aria-label="`Update ${props.row.name}`"
                    :to="editLink(props)"
                  >
                    <span v-text="props.row.status === 'Draft' ? 'Edit' : 'Update'" />
                  </router-link>
                  <button
                    class="button is-small is-secondary info-button"
                    tag="button"
                    :label="`View ${props.row.name}`"
                    :aria-label="`View ${props.row.name}`"
                    @click="openInspection(props.row)"
                  >
                    <span>View</span>
                  </button>
                </template>
              </v-client-table>
            </div>
          </div>
        </div>
      </div>
      <div
        v-if="!inspections.length && !loading"
        class="notification is-light p-t-lg p-b-lg is-info content has-text-centered"
      >
        <h4>
          <i
            class="fas fa-exclamation-circle"
            aria-hidden="true"
          />
          You haven't added an inspection / dust wipe report yet.
        </h4>
        <div class="columns is-centered has-text-left m-b-lg">
          <!-- Required -->
          <div
            v-if="calculateMessageIdentifier === 0"
            class="column is-6"
          >
            <p>{{ eligibilityCheck.numberOfUnits }} certifications required beginning {{ $dayjs(getRegion.startDate).format('MMM DD, YYYY') }}</p>
            <p
              v-if="eligibilityCheck.propertyType === 'Residential'"
              v-html="$wording.submission_details.required"
            />
            <p
              v-else
              v-html="$wording.submission_details.required_daycare"
            />
            <p><small v-html="$wording.submission_details.contact_lhhp" /></p>
            <p><small v-html="$wording.submission_details.more_info_3" /></p>
          </div>

          <!-- No required -->
          <div
            v-if="calculateMessageIdentifier === 1"
            class="column is-6"
          >
            <p v-html="$wording.submission_details.no_required" />
            <p><small v-html="$wording.submission_details.contact_us_email" /></p>
            <p><small v-html="$wording.submission_details.more_info_3" /></p>
          </div>

          <!-- Required before applying -->
          <div
            v-if="calculateMessageIdentifier === 2"
            class="column is-6"
          >
            <p>{{ eligibilityCheck.numberOfUnits }} certifications required beginning {{ $dayjs(getRegion.startDate).format('MMM DD, YYYY') }}</p>
            <p v-html="$wording.submission_details.will_be_required" />
            <p><small v-html="$wording.submission_details.contact_lhhp" /></p>
            <p><small v-html="$wording.submission_details.more_info_3" /></p>
          </div>

          <!-- Will be required -->
          <div
            v-if="calculateMessageIdentifier === 3"
            class="column is-6"
          >
            <p>{{ eligibilityCheck.numberOfUnits }} certifications required beginning {{ $dayjs(getRegion.startDate).format('MMM DD, YYYY') }}</p>
            <p
              v-html="$sprintf(
                $wording.submission_details.will_be_required_date,
                $dayjs(getRegion.startDate).format('MMM DD, YYYY')
              )"
            />
            <p><small v-html="$wording.submission_details.contact_lhhp" /></p>
            <p><small v-html="$wording.submission_details.more_info_3" /></p>
          </div>
        </div>
        <button
          v-if="calculateMessageIdentifier === 0"
          class="button is-secondary submit-button add-certification"
          @click="gotoSubmitInspections"
        >
          <span>ADD CERTIFICATION</span>
          <span class="icon">
            <i
              class="fas fa-plus-square"
              aria-hidden="true"
            />
          </span>
        </button>
        <!-- <small>
          <a
            class="m-t-sm is-block has-text-centered is-link"
            @click="withdrawCertification"
          >
            Withdraw certification
          </a>
        </small> -->
      </div>
    </div>

    <issue-warning
      :inspections="inspections"
    />

    <more-info
      id="not-found"
      title="Lead disclosure not found"
      :visible="notFound"
      @closed="$router.push({ name: 'home' });"
    >
      <div class="content">
        The lead disclosure you are trying to open doesn't exist, and it won't be used to calculate a property Lead Disclosure Certification for licensing purposes.
      </div>
    </more-info>
    <router-view />
  </div>
</template>

<script>
import EligibilityCheckInfo from '@/mixins/eligiblityCheckInfo';
import MoreInfo from '@/components/modals/MoreInfo';
import IssueWarning from '@/pages/forms/IssueWarning';
import tippy from 'tippy.js';
import { options } from '@/config/tableOptions';

export default {
  name: "SubmissionDetails",
  components: {
    MoreInfo,
    IssueWarning,
  },
  extends: EligibilityCheckInfo,
  data() {
    return {
      notFound: false,
      tooltipInstance: null,
      loading: true,
      modalInspectionId: null, // This is the inspection to load when you do click on view inspection button.
      customUnits: [], // Remove this
      showNotification: true,

      tableOptions:  options({
        headings: {
          name: "Unit name",
          inspectionDate: "Inspection date",
          expirationDate: "Exp. date",
          licenseOrTechnicianNumber: "License or technician #",
          inspectionType: "Inspection type",
          actions: '',
        },
        sortable: [ 'name' ],
        orderBy: {
          ascending: true,
          column: 'name',
        },
        columnsClasses: {
          inspectionType: 'has-text-centered',
          expirationDate: 'is-date nowrap',
          inspectionDate: 'is-date nowrap',
          name: 'nowrap',
          licenseOrTechnicianNumber: 'nowrap has-text-centered',
          actions: 'actions-buttons',
        },
        filterable: [
          'name',
          'status',

          // TODO: Date search seems to be broken
          'inspectionDate',
          'expirationDate',

          'inspectionType',
          'licenseOrTechnicianNumber',
        ],
      }),
      tableColumns: [
        'actions',
        'name',
        'status',
        'inspectionDate',
        'expirationDate',
        'licenseOrTechnicianNumber',
        'inspectionType',
        'report',
      ],
    };
  },
  computed: {
    inspections() {
      return this.$store.state.properties.inspections.data || [];
    },
    submitCertification() {
      return this.inspections.length < this.eligibilityCheck.numberOfUnits;
      // return this.inspections.length < this.eligibilityCheck.numberOfUnits || this.inspections.findIndex(insp => {
      //   return insp.draft || !/Passed|Pending/gi.test(insp.status); 
      // }) !== -1;
    },
    getRegion() {
      return this.$store.getters['properties/getRegion'](this.selectedProperty.zip_code);
    },
    calculateMessageIdentifier() {
      if (this.eligibilityCheck.prior1978 === undefined
        || this.eligibilityCheck.propertyType === undefined
        || this.getRegion.startDate === undefined
        || this.eligibilityCheck.childUnderSix === undefined) {
        return -1;
      }

      if (!this.eligibilityCheck.prior1978) {
        return 1;
      } 
      if (this.eligibilityCheck.propertyType === 'Daycare') {
        return 0;
      } 
      if (this.$dayjs().isAfter(this.$dayjs(this.getRegion.startDate))) {
        return 2;
      } else if (this.eligibilityCheck.childUnderSix) {
        return 2;
      } 
      return 3; 
    },
    numberOfUnitsSubmitted() {
      return this.inspections.filter(el => el.status !== 'Draft').length;
    },
  },
  watch: {
    '$route'() {
      this.getInspections();
    },
    foundLicenseData() {
      this.setTooltipState();
    },
  },
  async beforeMount() {
    await this.getInspections();

    await this.$nextTick(() => {
      if (this.$refs['license-tooltip']) {
        this.tooltipInstance = tippy(this.$refs['license-tooltip'], {
          theme: 'material',
          arrow: true,
          maxWidth: 180,
        });
        this.setTooltipState();
      }
    });
  },
  methods: {
    gotoSubmitInspections() {
      this.$router.push({ name: 'submit-inspections', params: this.$route.params });
    },
    showMoreInfo() {
      if (this.$refs['more-info-modal']) {
        this.$refs['more-info-modal'].show();
      }
    },
    getExpirationDate(date) {
      let inspectionDate = this.$dayjs(date);
      let feb012020 = this.$dayjs('2020-02-01');
      
      if (inspectionDate.isBefore(feb012020)) {
        return inspectionDate.add(2, 'y').format('MM/DD/YYYY');
      } 
      return inspectionDate.add(4, 'y').format('MM/DD/YYYY');
      
    },
    setTooltipState() {
      if (this.tooltipInstance) {
        if (this.foundLicenseData === false) {
          this.tooltipInstance.enable();
        } else {
          this.tooltipInstance.disable();
        }
      }
    },
    async getInspections() {
      if (!this.eligibilityCheck.id) {
        this.notFound = true;
      }

      try {
        this.loading = true;
        await this.$store.dispatch('properties/getInspections', { uuid: this.$route.params.uuid });
        this.loading = false;
      } catch (err) {
        console.log(err);
        this.loading = false;
      }
      return;
    },
    editLink(props) {
      const params = { uuid: this.$route.params.uuid, unit: props.row.name };
      if (/Passed|Pending/gi.test(props.row.status) && this.isAdmin) {
        return { name:'update-inspections-one', params };
      }
      return { name:'submit-inspections-one', params };
    },
    openInspection(inspection) {
      // this.modalInspectionId = inspection.id;
      // this.$modal.show('view-inspection-modal');
      this.$router.push({ name: 'view-inspections-one',
        params: {
          inspection: inspection.id,
          uuid: this.eligibilityCheck.id,
        },
      });
    },

    // async withdrawCertification() {
    //   if (await this.submitGuard('Are you sure you would like to withdraw the selected certification?')) {
    //     if (await this.$store.dispatch('properties/deleteSubmission', this.eligibilityCheck.id)) {
    //       this.$store.commit('properties/removeSubmission', this.eligibilityCheck.id);
    //       this.$router.push({ name: 'home' });
    //     }
    //   }
    // },
  },
};
</script>

<style lang="scss" scoped>
  .table {
    tbody {
      tr {
        th {
          width: 350px !important;
          vertical-align: middle;
        }
      }
    }
  }
  .notification.is-info {
    h4 {
      color: $dark-ben-franklin;
      margin-bottom: 1.5rem;
    }
    color: $dark-gray;
  }
  @include until(1024px) {
    .m-t-mobile {
      margin-top: 0.5rem;
    }
  }
</style>
<style lang="scss">
  .top .vdp-datepicker__calendar {
    position: absolute;
    top: -282px;
  }
  .custom-table-with-right-button-and-not-limit {
    &.VueTables--client {
      > .columns {
        .column.is-12:not(.VuePagination__count) {
          display: flex;
          .VueTables__search {
            flex: 1 1 auto;
          }
          .custom-button-flex {
              flex-grow: 0;
              flex-shrink: 1;
              flex-direction: column;
              justify-content: flex-end;
          }
        }
        @include until(1024px) {
          .column.is-12:not(.VuePagination__count) {
            display: block;
            .field {
              display: block;
              float: none !important;
            }
            .custom-button-flex {
              margin-top: 1rem;
            }
          }
          .VueTables__limit {
            display: none !important;
          }
        }
      }
    }
  }
</style>
